import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';

import { MachineInfoDB } from '../../interfaces/machine-info.interface';

@Injectable({
  providedIn: 'root'
})
export class ManageSystemSelectionServiceService {

  public selectChanged: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public selectionStopped: Subject<void> = new Subject<void>();
  private selectedValues: string[] = [];

  constructor() {
    this.selectChanged.subscribe((data: string[]) => this.selectedValues = data);
  }

  public selectByIds(physicalAddresses: string[]): void {
    this.unselectAll();
    physicalAddresses.forEach((physicalAddress: string) => this.selectItem(physicalAddress));
  }

  public selectItem(physicalAddress: string): void {
    this.selectedValues.push(physicalAddress);
    this.selectChanged.next(this.selectedValues);
  }

  public unselectItem(physicalAddress: string): void {
    _.remove(this.selectedValues, (value: string) => value === physicalAddress);
    this.selectChanged.next(this.selectedValues);
  }

  public unselectAll(): void {
    this.selectChanged.next([]);
  }

  public selectAll(fullMachineInfo: MachineInfoDB[]): void {
    if (fullMachineInfo) {
      this.selectChanged.next(
        fullMachineInfo.map((machineInfo: MachineInfoDB) => machineInfo.PhysicalAddress)
      );
    }
  }
}
